import { handleActions } from 'redux-actions';
import cloneDeep from 'lodash/cloneDeep';

// actions types
const TEST = 'summary/test';

// initial state
const initialState = {
	data: null,
	error: false
};

// actions
export const actions = {
	test: ({
		type: TEST
	})
};

// reducers
export default handleActions({
	[TEST]: (state, action) => state
}, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.root.data,
	getError: state => state.root.error
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/summary/index.js